import config from "config";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useDownloadRequest } from "../../../../hooks/useDownloadRequest.tsx";
import { ActionExpandedComponent } from "../Reusable/MailActionsComponent.js";

const SplitPanelActionComponent = ({ downloandAction, tooltipTextKey }) => {
  return (
    <ActionExpandedComponent
      iconName="download"
      textKey={tooltipTextKey}
      clickAction={downloandAction}
    />
  );
};

export const DownloadpageActionComponent = ({
  data,
  isJmForm,
  isFromSplitPanel,
  hideAdditioanlIcons = false,
}) => {
  const { getPath } = useContent();
  const { getUserData, isPremium, isBusiness } = useUser();

  const { handleDownload, isWaitingForResponse } = useDownloadRequest({
    mailId: data.id,
    userId: getUserData().UserId,
    inboxFilesList:
      data.filesQuantity === 1
        ? data.filesData
          ? Object.keys(data.filesData)
          : null
        : null,
  });

  var dateInPast = function (firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
      return true;
    }

    return false;
  };

  const expDate = new Date(data.expirationDate);
  const today = new Date();

  const isDownload =
    (!dateInPast(expDate, today) || data.mailStatus !== "removed") &&
    isJmForm &&
    (isPremium() || isBusiness());

  const actionHandle = async () => {
    if (isDownload) {
      handleDownload();
    } else {
      const baseUrl = data?.bucketName
        ? data.bucketName.includes("jumbomail1")
          ? window.location.origin
          : data.bucketName.replace("files.", "")
        : config.baseurl;

      window.open(`${baseUrl}${getPath()}gallery/${data.id}`);
    }
  };

  if (data.mailStatus === "uploading") return null;

  return (
    <div
      className="download-inbox-icon-container"
      onClick={() => actionHandle()}
    >
      {!isWaitingForResponse ? (
        <>
          {isFromSplitPanel ? (
            <SplitPanelActionComponent
              downloandAction={actionHandle}
              tooltipTextKey={
                isDownload
                  ? "inbox-donwload-files-tooltip"
                  : "tooltip-inbox-show-download-page"
              }
            />
          ) : (
            <Tooltip
              id={`donwloadInboxAction${data.id}`}
              tooltipTextKey={
                isDownload
                  ? "inbox-donwload-files-tooltip"
                  : "tooltip-inbox-show-download-page"
              }
            >
              <Icon name="download" iconClass="download-icon" />
            </Tooltip>
          )}
          {data.payment && !hideAdditioanlIcons ? (
            <div className="jumbopay-noti-icon-container">
              <Tooltip
                id={"jumbopayIconOnInboxDownload"}
                tooltipTextKey={"inbox-mail-with-jumbopay-tooltip"}
              >
                <Icon name="jumbopay" orange />
              </Tooltip>
            </div>
          ) : null}
          {data.security && !hideAdditioanlIcons ? (
            <div
              className={`security-noti-icon-container${
                data.payment ? " second" : ""
              }`}
            >
              <Tooltip
                id={"securityIconOnInboxDownload"}
                tooltipTextKey={"inbox-mail-with-security-tooltip"}
              >
                <Icon name="lock-closed-solid" white />
              </Tooltip>
            </div>
          ) : null}
        </>
      ) : (
        <LoadingImageElement />
      )}
    </div>
  );
};
